/** @jsxImportSource @emotion/react */
import React from 'react'

interface MyRegistrationsIconProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number
  color?: string
}

const MyRegistrationsIcon: React.FC<MyRegistrationsIconProps> = ({
  size,
  color,
  className,
  style,
  ...rest
}) => {
  return (
    <span className={`anticon ${className || ''}`} style={style} {...rest}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size ? `${size}px` : '1em'}
        height={size ? `${size}px` : '1em'}
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M11.5 8C12.6046 8 13.5 7.10457 13.5 6C13.5 4.89543 12.6046 4 11.5 4C10.3954 4 9.5 4.89543 9.5 6C9.5 7.10457 10.3954 8 11.5 8Z'
          fill={color || 'currentColor'}
        />
        <path
          d='M5.5 20C6.60457 20 7.5 19.1046 7.5 18C7.5 16.8954 6.60457 16 5.5 16C4.39543 16 3.5 16.8954 3.5 18C3.5 19.1046 4.39543 20 5.5 20Z'
          fill={color || 'currentColor'}
        />
        <path
          d='M5.5 14C6.60457 14 7.5 13.1046 7.5 12C7.5 10.8954 6.60457 10 5.5 10C4.39543 10 3.5 10.8954 3.5 12C3.5 13.1046 4.39543 14 5.5 14Z'
          fill={color || 'currentColor'}
        />
        <path
          d='M5.5 8C6.60457 8 7.5 7.10457 7.5 6C7.5 4.89543 6.60457 4 5.5 4C4.39543 4 3.5 4.89543 3.5 6C3.5 7.10457 4.39543 8 5.5 8Z'
          fill={color || 'currentColor'}
        />
        <path
          d='M17.5 8C18.6046 8 19.5 7.10457 19.5 6C19.5 4.89543 18.6046 4 17.5 4C16.3954 4 15.5 4.89543 15.5 6C15.5 7.10457 16.3954 8 17.5 8Z'
          fill={color || 'currentColor'}
        />
        <path
          d='M10.5 18.07V19.5C10.5 19.78 10.72 20 11 20H12.4C12.53 20 12.66 19.95 12.75 19.85L18.58 14.02L16.46 11.9L10.65 17.71C10.55 17.81 10.5 17.94 10.5 18.07Z'
          fill={color || 'currentColor'}
        />
        <path
          d='M11.53 14L13.5 12.03V12C13.5 10.9 12.6 10 11.5 10C10.4 10 9.5 10.9 9.5 12C9.5 13.1 10.4 14 11.5 14H11.53Z'
          fill={color || 'currentColor'}
        />
        <path
          d='M20.35 11.56L18.94 10.15C18.74 9.95 18.43 9.95 18.23 10.15L17.17 11.21L19.29 13.33L20.35 12.27C20.55 12.07 20.55 11.76 20.35 11.56Z'
          fill={color || 'currentColor'}
        />
      </svg>
    </span>
  )
}

export default MyRegistrationsIcon
